import React from 'react';
import {
  Cookie,
  AlertCircle,
  CheckCircle2,
  AlertTriangle,
  Ban,
  ArrowRight,
  Info,
  ShieldAlert
} from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

const TipoAlimentacionCard = ({ tipoAlimentacion }) => {
  if (!tipoAlimentacion) return null;

  const { croquetas, alimentosProhibidos } = tipoAlimentacion;

  return (
    <Card className="overflow-hidden bg-white">
      <CardHeader className="border-b bg-gradient-to-r from-orange-500/10 via-orange-500/5 to-transparent p-5 sm:p-6">
        <div className="flex items-center gap-3">
          <div className="p-2.5 sm:p-3 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl shadow-md">
            <Cookie className="h-5 w-5 sm:h-6 sm:w-6 text-white" />
          </div>
          <div>
            <CardTitle className="text-xl sm:text-2xl text-gray-800 font-semibold">
              Tipo de Alimentación
            </CardTitle>
            <p className="text-base text-gray-500 mt-1">
              Guía de alimentación recomendada
            </p>
          </div>
        </div>
      </CardHeader>

      <CardContent className="p-4 sm:p-5 space-y-4">
        {/* Sección de Croquetas */}
        <div className="bg-gradient-to-br from-orange-50 to-white rounded-xl border border-orange-100 overflow-hidden hover:shadow-md transition-all">
          <div className="p-4 space-y-3">
            <div className="flex items-center gap-2">
              <div className="p-2 bg-white rounded-lg shadow-sm">
                <Cookie className="h-5 w-5 sm:h-6 sm:w-6 text-orange-500" />
              </div>
              <h3 className="text-lg sm:text-xl font-medium text-gray-900">
                Croquetas Recomendadas
              </h3>
            </div>

            {/* Por qué es importante */}
            <div className="bg-orange-50 p-3 rounded-lg border border-orange-100">
              <div className="flex items-start gap-2">
                <Info className="h-5 w-5 mt-0.5 text-orange-500" />
                <p className="text-base text-gray-700">{croquetas.porQueEsImportante}</p>
              </div>
            </div>

            {/* Recomendaciones */}
            <div className="space-y-2">
              {croquetas.recomendaciones.map((recomendacion, idx) => (
                <div key={idx} 
                     className="flex items-start gap-2 bg-white p-3 rounded-lg border border-orange-100 
                              group hover:border-orange-200 hover:shadow-sm transition-all">
                  <CheckCircle2 className="h-5 w-5 mt-0.5 text-orange-500" />
                  <p className="text-base text-gray-700">{recomendacion}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Sección de Alimentos Prohibidos */}
        <div className="bg-gradient-to-br from-red-50 to-white rounded-xl border border-red-100 overflow-hidden hover:shadow-md transition-all">
          <div className="p-4 space-y-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="p-2 bg-white rounded-lg shadow-sm">
                  <Ban className="h-5 w-5 sm:h-6 sm:w-6 text-red-500" />
                </div>
                <h3 className="text-lg sm:text-xl font-medium text-gray-900">
                  Alimentos Prohibidos
                </h3>
              </div>
              <ShieldAlert className="h-6 w-6 sm:h-7 sm:w-7 text-red-500" />
            </div>

            <div className="grid gap-3 sm:grid-cols-2">
              {alimentosProhibidos.map((alimento, idx) => (
                <div key={idx} 
                     className="bg-white p-3 rounded-lg border border-red-100 space-y-2 
                              hover:shadow-sm hover:border-red-200 transition-all">
                  <div className="flex items-center justify-between gap-2">
                    <span className="text-base font-medium text-gray-900">
                      {alimento.alimento}
                    </span>
                    <AlertTriangle className="h-5 w-5 text-red-500" />
                  </div>
                  <div className="flex items-start gap-2 bg-red-50 p-2 rounded-lg">
                    <ArrowRight className="h-5 w-5 mt-0.5 text-red-500" />
                    <p className="text-base text-gray-700">{alimento.razon}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-red-100 p-3 rounded-lg border border-red-200">
              <div className="flex items-start gap-2">
                <AlertCircle className="h-5 w-5 mt-0.5 text-red-600" />
                <div>
                  <p className="text-base font-medium text-red-800 mb-1">¡Atención!</p>
                  <p className="text-base text-red-700">
                    Mantén estos alimentos fuera del alcance de tu mascota. Pueden ser muy peligrosos para su salud.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default TipoAlimentacionCard;